<template>
  <div class="invoice-information-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'invoice-information-container',
}
</script>

<style scoped>
.invoice-information-container {
  background: #ffffff;
  border-radius: 3.25px;
  padding: 30px;
  margin: 16px 0;
}
</style>